import BaseModel from "./BaseModel";

export default class MobilityContractPayoutConfig extends BaseModel {
  id: number;
  accountId: number;
  walletPayoutAmountCents: number;
  maxMobilityContractPayoutsPerApartment: number;
  walletPayoutMessage: string;

  static __dates = ["updatedAt", "createdAt"];

  constructor(data: any) {
    super(data, MobilityContractPayoutConfig.__dates);
    this.id = data.id;
    this.accountId = data.accountId;
    this.walletPayoutAmountCents = data.walletPayoutAmountCents;
    this.maxMobilityContractPayoutsPerApartment = data.maxMobilityContractPayoutsPerApartment;
    this.walletPayoutMessage = data.walletPayoutMessage;
  }
}
